import { Image, Page, Text, View } from "@react-pdf/renderer";
import React from "react";
import { styles } from "../../style";
import assets from "../../../../../../../../../assets/assets";

export const Page6 = ({ data }) => {
  return (
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
        <Text
          style={[
            styles.title,
            styles.textBold,
            { letterSpacing: 0.2, marginTop: 8 },
          ]}
        >
          АРАВ.БУСАД
        </Text>
      </View>
      <View style={styles.spaceY}>
        <View style={styles.spaceX}>
          <Text>10.1.</Text>
          <Text style={styles.text}>
            Энэхүү Гэрээний Талууд харилцан гарын үсэг зурж, тамга тэмдгээр
            баталгаажуулснаар хүчин төгөлдөр болно.
          </Text>
        </View>
        <View style={styles.spaceX}>
          <Text>10.2.</Text>
          <Text style={styles.text}>
            Энэхүү Гэрээнд Талууд харилцан тохиролцсоны үндсэн дээр бичгээр
            үйлдсэн нэмэлт, өөрчлөлт оруулж болох бөгөөд Талууд гарын үсэг зурж
            тамга тэмдэг дарснаар хүчин төгөлдөр болно. Гэрээний эх хувьд
            засварласан буюу бусад аргаар оруулсан аливаа нэмэлт өөрчлөлтийг
            хүчингүйд тооцно. Энэхүү нэмэлт, өөрчлөлт нь Гэрээний салшгүй хэсэг
            байна.
          </Text>
        </View>
        <View style={styles.spaceX}>
          <Text>10.3.</Text>
          <Text style={styles.text}>
            Гэрээ байгуулсныг гэрчлэх үүднээс Гэрээг хоёр хувь үйлдэж, Талууд
            хууль эрх зүйн хүчинтэй нэг нэг хувийг тус тус хадгална.
          </Text>
        </View>
      </View>
      <View style={styles.header}>
        <Text
          style={[
            styles.title,
            styles.textBold,
            { letterSpacing: 0.5, marginTop: 64, paddingBottom: 24 },
          ]}
        >
          ГЭРЭЭ БАЙГУУЛСАН:
        </Text>
      </View>

      <View style={[styles.date, { position: "relative" }]}>
        <View style={[styles.spaceY, { textAlign: "left" }]}>
          <Text style={styles.textBold}>“М Мюзик Дистрибюшн” ХХК-ийн</Text>
          <Text style={styles.textBold}>төлөөлж:</Text>
          <Text style={styles.textBold}>Гүйцэтгэх захирал О. Мөнхтулга:</Text>
          <br />
          {/* <Text style={styles.textBold}>.....................</Text> */}
          <View style={styles.imageContainer}>
            <Image
              src={assets.image.signatureTulgaa}
              style={{ width: 100, height: 60 }}
            />
          </View>
          <Text style={styles.textBold}> Утас: 77077766 </Text>
          <Text style={styles.textBold}>
            И-мэйл: <Text style={styles.link}>contact@mmusic.mn</Text>{" "}
          </Text>
        </View>
        <View style={[styles.spaceY, { textAlign: "right" }]}>
          <Text style={styles.textBold}>
            {" "}
            <Text style={styles.textBold}>
              {data?.last_name ?? "........"}
            </Text>{" "}
            .
            <Text style={styles.textBold}>
              {data?.first_name ?? "........"}
            </Text>{" "}
            -г
          </Text>
          <Text style={styles.textBold}>төлөөлж:</Text>
          <Text style={[styles.textBold, { paddingVertical: 8 }]}></Text>
          <br />
          <View style={styles.imageContainer}>
            {data?.signature?.url ? (
              <Image src={data.signature.url} style={styles.image} />
            ) : (
              ".............."
            )}
          </View>
          <Text style={styles.textBold}>
            {" "}
            <Text>Утас:</Text>{" "}
            <Text style={styles.textBold}>
              {data?.phone ?? " ................"}
            </Text>{" "}
          </Text>
          <Text style={styles.textBold}>
            <Text>И-мэйл:</Text>{" "}
            <Text style={styles.textBold}>
              {data?.email ?? " ................"}
            </Text>{" "}
          </Text>
        </View>
        <View
          style={{
            position: "absolute",
            paddingTop: 8,
            width: "100%",
            zIndex: "99",
            opacity: 0.73,
          }}
        >
          <Image
            src={assets.image.documentMMusic}
            style={{ width: 180, height: 180 }}
          />
        </View>
      </View>
    </Page>
  );
};

export default Page6;
